import { IReduxState } from '../../../../types/redux';

export function priceLteSelector(state: IReduxState): number | undefined {
  return state.filters.jsonQuery.price?.value.lte;
}
